<template>
<div>
  <div class="simulation-amount-details">
    <div class="simulation-amount-detail">
      <span class="simulation-amount-title">税サ抜小計</span>
      <span class="simulation-amount">
        &yen;{{this.amountDetail.amountWithoutTax | priceFormat}}
      </span>
    </div>
  </div>
  <div class="simulation-amount-details">
    <div class="simulation-amount-detail">
      <span class="simulation-amount-title">サービス料 ({{this.amountDetail.serviceCharge}}%)</span>
      <span class="simulation-amount">
        &yen;{{this.amountDetail.serviceChargePrice | priceFormat}}
      </span>
    </div>
  </div>
  <div class="simulation-amount-details">
    <div class="simulation-amount-detail">
      <span class="simulation-amount-title">消費税 ({{this.amountDetail.normalTaxRate}}%)</span>
      <span class="simulation-amount">
        &yen;{{this.amountDetail.normalAmountOfTax | priceFormat}}
      </span>
    </div>
  </div>
  <div class="simulation-amount-details">
    <div class="simulation-amount-detail">
      <span class="simulation-amount-title">消費税 ({{this.amountDetail.reducedTaxRate}}%)</span>
      <span class="simulation-amount">
        &yen;{{this.amountDetail.reducedAmountOfTax | priceFormat}}
      </span>
    </div>
  </div>
</div>
</template>

<script>
import priceFormat from '@/filters/price-format'

export default {
  props: {
    amountDetail: {
      type: Object,
      required: true
    }
  },

  filters: {
    priceFormat,
  },
}
</script>
